import type { SxProps, Theme } from '@mui/material/styles';

type CreateAccountStyleMap = {
    root: SxProps<Theme>
    titleRow: SxProps<Theme>
    paper: SxProps<Theme>
    successContent: SxProps<Theme>
    infoAlert: SxProps<Theme>
    invitationBox: SxProps<Theme>
    invitationText: SxProps<Theme>
    successActions: SxProps<Theme>
    form: SxProps<Theme>
    formActions: SxProps<Theme>
};

export const createAccountStyles: CreateAccountStyleMap = {
    root: { maxWidth: 600, mx: 'auto', display: 'flex', flexDirection: 'column', gap: 3 },
    titleRow: { display: 'flex', alignItems: 'center', gap: 2 },
    paper: { border: '1px solid', borderColor: 'divider', borderRadius: 2, p: 3 },
    successContent: { display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'center', textAlign: 'center' },
    infoAlert: { width: '100%', textAlign: 'left' },
    invitationBox: {
        width: '100%',
        display: 'flex',
        gap: 1,
        alignItems: 'center',
        p: 1.5,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        bgcolor: 'action.hover',
    },
    invitationText: { flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontFamily: 'monospace' },
    successActions: { display: 'flex', gap: 2 },
    form: { display: 'flex', flexDirection: 'column', gap: 3 },
    formActions: { display: 'flex', justifyContent: 'flex-end', gap: 2, borderTop: '1px solid', borderColor: 'divider', pt: 2 },
};

export const invitationSuccessIconColor = 'green';
